export const jsonToQueryString = (jsonData) => {
    const u = new URLSearchParams(jsonData).toString()
    return u
}

export const ementies = {
    bed: "Bed",
    extrapathari: "Extra Pathari",
    gas: "Gas",
    geyser: "Geyser",
    sofa: "Sofa Set",
    fridge: "Fridge",
    wmachine: "Washing Machine",
}